(() => {
  const STORAGE_PREFIX = 'mt_model_form_dismissed_'

  const getStorageKey = (root) => {
    const sectionId = root.getAttribute('data-section-id') || 'default'
    return STORAGE_PREFIX + sectionId
  }

  const wasDismissed = (root) => {
    if (root.getAttribute('data-once-per-session') !== 'true') return false
    try {
      return sessionStorage.getItem(getStorageKey(root)) === '1'
    } catch (e) {
      return false
    }
  }

  const markDismissed = (root) => {
    if (root.getAttribute('data-once-per-session') !== 'true') return
    try {
      sessionStorage.setItem(getStorageKey(root), '1')
    } catch (e) {}
  }

  const lockScroll = (locked) => {
    document.body.classList.toggle('mt-model-form-open', locked)
  }

  const openModal = (root) => {
    root.hidden = false
    root.classList.add('is-open')
    root.setAttribute('aria-hidden', 'false')
    lockScroll(true)

    const dialog = root.querySelector('.mt-model-form__dialog')
    const status = root.querySelector('.mt-model-form__status')
    const focusTarget = status || dialog
    if (!focusTarget) return

    requestAnimationFrame(() => {
      try {
        focusTarget.focus({ preventScroll: true })
      } catch (e) {
        focusTarget.focus()
      }
    })
  }

  const closeModal = (root, { remember = true } = {}) => {
    root.classList.remove('is-open')
    root.setAttribute('aria-hidden', 'true')
    lockScroll(false)

    const onEnd = () => {
      if (!root.classList.contains('is-open')) {
        root.hidden = true
      }
      root.removeEventListener('transitionend', onEnd)
    }
    root.addEventListener('transitionend', onEnd)

    if (remember) markDismissed(root)
  }

  const initExpandableMessage = (root) => {
    const field = root.querySelector('[data-mt-model-form-expandable]')
    if (!field || field.__mtExpandableReady) return
    field.__mtExpandableReady = true

    const isMobile = () => window.matchMedia('(max-width: 750px)').matches

    const expand = () => {
      if (!isMobile()) return
      field.classList.add('is-expanded')
      field.style.height = 'auto'
      field.style.height = Math.max(field.scrollHeight, 100) + 'px'
    }

    const collapse = () => {
      if (!isMobile() || field.value.trim()) return
      field.classList.remove('is-expanded')
      field.style.height = ''
    }

    field.addEventListener('focus', expand)
    field.addEventListener('input', expand)
    field.addEventListener('blur', collapse)
    window.addEventListener('resize', () => {
      if (isMobile() && (field.matches(':focus') || field.value.trim())) {
        expand()
      } else {
        field.classList.remove('is-expanded')
        field.style.height = ''
      }
    })
  }

  const initModal = (root) => {
    if (root.__mtModelFormReady) return
    root.__mtModelFormReady = true

    const openOnLoad = !!root.querySelector('[data-mt-model-form-result]')
    const delaySec = Math.max(0, Number(root.getAttribute('data-delay')) || 3)

    root.querySelectorAll('[data-mt-model-form-close]').forEach((el) => {
      el.addEventListener('click', (event) => {
        event.preventDefault()
        closeModal(root)
      })
    })

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return
      if (!root.classList.contains('is-open')) return
      closeModal(root)
    })

    const form = root.querySelector('.mt-model-form__form')
    const submitButton = root.querySelector('.mt-model-form__submit')
    if (form && submitButton) {
      form.addEventListener('submit', () => {
        if (typeof form.checkValidity === 'function' && !form.checkValidity()) return
        submitButton.disabled = true
        submitButton.setAttribute('aria-disabled', 'true')
      })
    }

    initExpandableMessage(root)

    if (openOnLoad) {
      openModal(root)
      return
    }

    if (wasDismissed(root)) return

    window.setTimeout(() => {
      if (wasDismissed(root)) return
      openModal(root)
    }, delaySec * 1000)
  }

  const boot = () => {
    document.querySelectorAll('[data-mt-model-form]').forEach(initModal)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot)
  } else {
    boot()
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-mt-model-form]')
    if (root) initModal(root)
  })
})()
